import _default from './Progress';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Progress/index.js
// module id = 1594
// module chunks = 0